export default () => {
  const { page } = useContent()
  return inject('document', page)
}
